import { useState, useEffect } from "react";
import { BsPlus, BsPlusSquare, BsGear } from "react-icons/bs";
import { BsChatSquare } from "react-icons/bs";
import { Link } from "react-router-dom";
import Addbeats from "./Addbeats";
import Beatscont from "./Beatscont";
import firebase from "firebase";
import "firebase/storage";
import "firebase/firestore";
import { userPhone } from "./Firebase";

const Mybeats = () => {
  const firestore = firebase.firestore();
  const myPhone = localStorage.getItem("person-phone");
  const userPhone = localStorage.getItem("user-phone");
  const [myName, setMyName] = useState("");
  const [myFollowers, setMyFollowers] = useState("");
  const [myFollowing, setMyFollowing] = useState("");
  const [myPhoneCheck, setMyPhoneCheck] = useState("");
  const [myCaption, setMyCaption] = useState("");
  const [myDp, setMyDp] = useState("");
  const [showAddBeats, setShowAddBeats] = useState(false);
  const [myAudios, setMyAudios] = useState([]);
  const [followState, setFollowState] = useState("follow");

  const styling = { color: "black", fontSize: "20px", margin: "2px 15px" };
  const linkStyle = { color: "black", textDecoration: "none" };

  useEffect((a) => {
    if (myPhone !== null) {
      const myRef = firestore.doc(`users/${myPhone}`);

      myRef.get().then((snap) => {
        setMyName(snap.data().name);
        setMyPhoneCheck(snap.data().phone);
        setMyCaption(snap.data().caption);
        setMyDp(snap.data().dp);
        setMyFollowers(snap.data().followers.length);
        setMyFollowing(snap.data().following.length);
      });

      function getMyAudios() {
        const ref = firestore
          .collection(`users/${myPhone}/audios`)
          .orderBy("createdAt", "desc");
        const array = [];

        ref.get().then((docs) => {
          docs.forEach((snap) => {
            const myAudio = {
              dp: snap.data().dp,
              id: snap.id,
              name: snap.data().name,
              src: snap.data().src,
              audioName: snap.data().audioName,
              phone: snap.data().phone,
              likes: snap.data().likes,
            };
            array.push(myAudio);
            setMyAudios([...myAudios, ...array]);
          });
        });
      }
      getMyAudios();
      checkFollowState();
    }
  }, []);

  function checkFollowState() {
    const personPhone = localStorage.getItem("person-phone");
    const myPhone = localStorage.getItem("user-phone");
    const ref = firestore.doc(`users/${myPhone}`);
    ref.get().then((snap) => {
      const following = snap.data().following;
      const state = following.indexOf(personPhone);
      if (state !== -1) {
        setFollowState("unfollow");
      }
    });
  }

  function follow(e) {
    const personPhone = localStorage.getItem("person-phone");
    const myPhone = localStorage.getItem("user-phone");
    const personRef = firestore.doc(`users/${personPhone}`);
    const myRef = firestore.doc(`users/${myPhone}`);

    if (e.target.innerText === "follow") {
      personRef.update({
        followers: firebase.firestore.FieldValue.arrayUnion(myPhone),
      });
      myRef.update({
        following: firebase.firestore.FieldValue.arrayUnion(personPhone),
      });
      alert("you a now following ");
      setFollowState("unfollow");
    } else {
      personRef.update({
        followers: firebase.firestore.FieldValue.arrayRemove(myPhone),
      });
      myRef.update({
        following: firebase.firestore.FieldValue.arrayRemove(personPhone),
      });

      alert("You Unfollowed");

      setFollowState("follow");
    }
  }

  return (
    <div id="my-beats-page" className="page flex-col-start">
      <div className="my-beats-nav flex-end">
        {userPhone !== myPhoneCheck && (
          <span onClick={(e) => follow(e)}>{followState}</span>
        )}
        {userPhone === myPhoneCheck && (
          <BsPlusSquare
            style={styling}
            onClick={(e) => setShowAddBeats(!showAddBeats)}
          />
        )}
        {userPhone === myPhoneCheck && (
          <Link to="/Settings">
            <BsGear style={styling} />
          </Link>
        )}

        <Link to="/Chatroom" style={linkStyle}>
          <span>
            <BsChatSquare style={styling} />
          </span>
        </Link>
      </div>

      <div className="top flex-col-evenly">
        <div className="my-details ">
          <img src={myDp} />
          <div className="my-info flex-col">
            <span className="my-name">{myName}</span>
            <span>{myCaption}</span>
          </div>
          <div className="about-follows flex-evenly">
            <span>
              Followers <br /> {myFollowers}
            </span>

            <span>
              Following <br /> {myFollowing}
            </span>
          </div>
        </div>
      </div>

      <div className="center .flex-col-start">
        {myAudios.map((a) => {
          return (
            <Beatscont
              dp={a.dp}
              key={a.src}
              src={a.src}
              id={a.id}
              name={a.name}
              phone={a.phone}
              audioName={a.audioName}
              likes={a.likes}
            />
          );
        })}
      </div>

      {showAddBeats && (
        <Addbeats showState={(e) => setShowAddBeats(!showAddBeats)} />
      )}
    </div>
  );
};

export default Mybeats;
